
<ips-login (loggedIn)="returnToState($event)" imgSource="/assets/img/lgo_art_lgn_flex.png" imgAlt="IMAGINE SYMPHONY"></ips-login>
